import { SortOrder } from 'types/core/sortTypes';

export const SORT_OPTIONS_ORDERS = ['descend', 'ascend', null] as SortOrder[];
